import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHorizontalAlignLeftComponent } from "./med-icon-horizontal-align-left.component";

@NgModule({
  declarations: [
    MedIconHorizontalAlignLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHorizontalAlignLeftComponent,
  ],
})
export class MedIconHorizontalAlignLeftModule { }
